var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB1ConsumptionOtherUsages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 21.09l2-2.17 2 2.17V36h-4V21.09zM18 36h4V25.09l-2-2.17-2 2.17V36zm-7 0h4v-5.91l-2-2.17-2 2.17V36zM4 17.46L24.52 4.73 45 17.46V33h4V15.24L24.52 0 0 15.24V46h32v-4H4V17.46zM64 56a2 2 0 100 4 2 2 0 000-4zM32 17.09V36h4V17.09l-2-2.17-2 2.17zM76 40v36H40V40h36zm-3.88 17.89a14.36 14.36 0 10-14.36 14.35 14.37 14.37 0 0014.36-14.35zM52 56a2 2 0 100 4 2 2 0 000-4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/B1_Consumption_other_usages.39f45c9a.svg";
export { SvgB1ConsumptionOtherUsages as ReactComponent };